export const getBusinessPlansUrl = () => 'agency/business_plans';

export const getBusinessPlanUrl = (id: string) => `agency/business_plans/${id}`;

export const getAgencyPlanUrl = (id: number) => `agency/organization_plans/${id}`;
